var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.875L16.1442 5.02848C16.0046 3.91201 15.9348 3.35377 15.6721 2.9331C15.4406 2.56246 15.1062 2.26726 14.7097 2.08353C14.2597 1.875 13.6971 1.875 12.572 1.875H5.42802C4.30286 1.875 3.74028 1.875 3.29027 2.08353C2.89378 2.26726 2.55938 2.56246 2.32789 2.9331C2.06515 3.35377 1.99537 3.91201 1.85582 5.02848L1.5 7.875M4.125 10.875H13.875M4.125 10.875C2.67525 10.875 1.5 9.69975 1.5 8.25C1.5 6.80025 2.67525 5.625 4.125 5.625H13.875C15.3247 5.625 16.5 6.80025 16.5 8.25C16.5 9.69975 15.3247 10.875 13.875 10.875M4.125 10.875C2.67525 10.875 1.5 12.0503 1.5 13.5C1.5 14.9497 2.67525 16.125 4.125 16.125H13.875C15.3247 16.125 16.5 14.9497 16.5 13.5C16.5 12.0503 15.3247 10.875 13.875 10.875M4.5 8.25H4.5075M4.5 13.5H4.5075M9 8.25H13.5M9 13.5H13.5",
    stroke: "#5D8EA4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServer);
export default __webpack_public_path__ + "static/media/server.1f3d0f7a734b71aadb46a47aca5c687c.svg";
export { ForwardRef as ReactComponent };